import Components from "../../components";
import { useLocation } from "react-router-dom";

const Brand = ({ data, dataSetter }) => {
  const location = useLocation();
  const { name } = location.state;
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title={name || "category"}
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Category
        id="category"
        label="Category"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Brand;
